import { Checkbox } from "@/components/ui/checkbox";
import { AlertTriangle, FileText } from "lucide-react";

// Rechnungs-Option im Versandmitteilungs-Dialog
export const RechnungOption = ({ info, checked, onChange, testMode }) => {
  if (!info) return null;
  const label = info.modus === "mitsenden" ? `Rechnung mitsenden${info.nummer ? ` (${info.nummer})` : ""}` : "Rechnung erstellen und mitsenden";
  return (
    <div className={`p-3 rounded-md border ${info.enabled ? "border-slate-200" : "border-slate-200 bg-slate-50"}`} data-testid="vm-rechnung-box">
      <label className={`flex items-start gap-3 ${info.enabled ? "cursor-pointer" : "cursor-not-allowed opacity-70"}`}>
        <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} disabled={!info.enabled} className="mt-0.5" data-testid="vm-rechnung-checkbox" />
        <span className="text-sm">
          <span className="font-medium flex items-center gap-1.5"><FileText className="w-4 h-4 text-slate-500" /> {label}</span>
          {info.hinweis && <span className="block text-xs text-slate-500 mt-0.5" data-testid="vm-rechnung-hint">{info.hinweis}</span>}
          {info.modus === "erstellen" && info.enabled && !testMode && checked && (
            <span className="block text-xs text-slate-500 mt-0.5">Die Rechnung wird beim Senden in sevDesk erstellt (Briefpapier, Skonto, Nummernkreis), fertiggestellt (Status „Offen“) und als PDF angehängt.</span>
          )}
        </span>
      </label>
      {testMode && checked && info.modus === "mitsenden" && info.entwurf && (
        <p className="mt-2 text-xs text-amber-800 flex items-start gap-1.5" data-testid="vm-rechnung-testmode-entwurf">
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> Testmodus: Die Rechnung bleibt Entwurf – sie wird nur im Echtbetrieb fertiggestellt.
        </p>
      )}
      {testMode && checked && info.modus === "erstellen" && (
        <p className="mt-2 text-xs text-amber-800 flex items-start gap-1.5" data-testid="vm-rechnung-testmode-note">
          <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" /> Testmodus: Es wird keine Rechnung erstellt – die Testmail enthält nur einen Hinweis.
        </p>
      )}
    </div>
  );
};
